<template>
  <div>
    <card :title="$t('gc-rfConfig:rfConfig')">
      <div slot="card-body">
        <!-- Mono chart -->
        <rf-config-chart-mono v-if="isMono && !isSX1302()" id="monoChart" :modem="rfConfigObject.SX1301_conf" />
        <rf-config-chart-mono v-if="isMono && isSX1302()" id="monoChart" :modem="rfConfigObject.SX130x_conf" />

        <!-- One multi chart per modem -->
        <template v-if="isMulti">
          <!-- No support of multi sx1302 gateways ! -->
          <rf-config-chart-multi v-for="(modem, i) in rfConfigObject.SX1301_array_conf" :id="'multiChartModem-' + i" :key="i" :modem="modem" />
        </template>

        <h3 v-if="canUseVisualEditor" class="d-flex justify-content-between mt-3">
          {{ $t(canUseVisualEditor && !useRawEditor ? 'gc-rfConfig:visualEditor' : 'gc-rfConfig:rawEditor') | capitalize }}
          <button v-if="canUseVisualEditor" id="switchEditorButton" class="btn btn-flat btn-sm" @click="switchEditor">{{ $t(!useRawEditor ? 'gc-rfConfig:useRawEditor' : 'gc-rfConfig:useVisualEditor') }}</button>
        </h3>

        <rf-config-form-mono v-if="isMono && canUseVisualEditor && !useRawEditor" v-model="rfConfig" :radio-type="isSX1302()?'SX130x':'SX1301'" :frequency="typeFrequency" @validate="result => { validationResult=result }" />
        <rf-config-form-multi v-if="isMulti && canUseVisualEditor && !useRawEditor" v-model="rfConfig" @validate="result => { validationResult=result }" />

        <rf-config-raw v-show="!canUseVisualEditor || useRawEditor" v-model="rfConfig" />
      </div>

      <div slot="card-footer">
        <button id="sendButton" :disabled="disabled" class="btn btn-primary" @click="send">{{ $t('gc-rfConfig:send') }}</button>
      </div>
    </card>
  </div>
</template>

<script>
import { isEmpty } from 'lodash-es'
import { mapGetters } from 'vuex'
import to from '@/modules/await-to-js'
import eventBus from '@/modules/eventBus'

import RfConfigRaw from './RfConfigRaw'
import RfConfigFormMono from './RfConfigFormMono'
import RfConfigFormMulti from './RfConfigFormMulti'
import RfConfigChartMono from './RfConfigChartMono'
import RfConfigChartMulti from './RfConfigChartMulti'

export default {
  components: { RfConfigChartMono, RfConfigChartMulti, RfConfigFormMono, RfConfigFormMulti, RfConfigRaw },

  props: {
    eui: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      rfConfig: '',
      getting: false,
      sending: false,
      // Editors
      useRawEditor: false,
      validationResult: true
    }
  },

  computed: {
    ...mapGetters(['gateway']),

    rfConfigObject () {
      // Return default object before getting data
      if (!this.rfConfig) return { SX1301_conf: {}, SX1301_array_conf: [] }
      // Parse string into object
      return JSON.parse(this.rfConfig)
    },

    isMono () {
      return this.gateway.description && (
        this.gateway.description.toLowerCase().indexOf('mono') !== -1 ||
        this.gateway.description.toLowerCase().indexOf('wirnet ifemtocell') !== -1 ||
        this.gateway.description.toLowerCase().indexOf('wirnet station') !== -1 ||
        this.gateway.description.toLowerCase().indexOf('wirnet istation') !== -1 ||
        this.isSX1302()
      )
    },

    isMulti () {
      return this.gateway.description && (
        this.gateway.description.toLowerCase().indexOf('loc') !== -1 ||
        this.gateway.description.toLowerCase().indexOf('highway') !== -1
      )
    },

    typeFrequency () {
      if (isEmpty(this.gateway) || !this.canUseVisualEditor) return 0
      // if (this.gateway.region) return Number(this.gateway.region.substring(2))
      // Remove "(" and ")" from description: TYPE_LORA_MONO(868) WTF for this hugly hack. but the objectiv is to not move too many things...
      if (this.gateway.description) return Number(this.gateway.description.split('(')[1].split(')')[0])
      else return 0
    },

    canUseVisualEditor () {
      if (isEmpty(this.gateway)) return false
      return this.gateway.description && (this.isMono || this.isMulti)
    },

    disabled () {
      return isEmpty(this.rfConfig) || this.sending
    }
  },

  watch: {
    eui () {
      // Reset data, and get data from new gateway
      this.rfConfig = ''
    },

    gateway () {
      // Do not refresh is we olready have the data
      if (!isEmpty(this.rfConfig) || this.getting) return

      this.getRfConfig()
    }
  },

  created () {
    this.getRfConfig()
  },

  methods: {
    isSX1302 () {
      return this.gateway.description && (
        this.gateway.description.toLowerCase().indexOf('Wirnet iZeptoCell'.toLowerCase()) !== -1
      )
    },
    async getRfConfig () {
      if (isEmpty(this.gateway)) return

      if (!this.gateway.connection) {
        eventBus.$emit('message-info', this.$t('gc-rfConfig:gatewayNotConnected'))
        return
      }

      this.getting = true
      let error, response
      [error, response] = await to(this.$api.getGatewayCurrentConfiguration(this.gateway, { groups: 'lan' }))
      if (!error && response) this.rfConfig = response.data.configRadio ? response.data.configRadio.replace(/\/\*[^*]*\*\//g, '') : ''

      this.getting = false
    },

    async send () {
      if (!this.validationResult) return

      let error
      [error] = await to(this.$api.updateGatewayCurrentConfiguration(this.gateway, { configRadio: this.rfConfig }))
      if (!error) eventBus.$emit('message-success', this.$t('gc-rfConfig:sendSuccess'))

      this.sending = false
    },

    switchEditor () {
      this.useRawEditor = !this.useRawEditor
    }
  }
}
</script>
